import { configureStore } from "@reduxjs/toolkit";
import landingReducer from "./features/Landing/landingSlice";
import createRoleReducer from "./features/CreateRole/createRoleSlice"
import religionReducer from "./EmployeeRegistration/religionSlice";
import genderReducer from "./EmployeeRegistration/genderSlice";
import bloodgroupReducer from "./EmployeeRegistration/bloodgroupSlice";
import departmentReducer from "./EmployeeRegistration/departmentSlice";
import gradeReducer from "./EmployeeRegistration/gradeSlice";
import salutationReducer from "./EmployeeRegistration/salutatinSlice";
import categoryReducer from "./EmployeeRegistration/categorySlice";
import subcategoryReducer from "./StudentRegistration/subcategorySlice";
import courseReducer from "./StudentRegistration/courseSlice";
import coachingReducer from "./StudentRegistration/coachingSlice";
import schoolNameReducer from "../Redux/StudentRegistration/schoolSlice";
import classReducer from "../Redux/StudentRegistration/classSlice";
import mediumReducer from "../Redux/StudentRegistration/mediumSlice";
import boearReducer from "../Redux/StudentRegistration/boardSlice";
import stateReducer from "../Redux/StudentRegistration/stateSlice";
import classTypeReducer from "../Redux/StudentRegistration/classTypeSlice";
import batchReducer from "../Redux/features/AssignTest/batchSlice";
import testNameReducer from "../Redux/features/AssignTest/testnameSlice";
import testSeriesReducer from "../Redux/features/TestSeries/testSeriesSlice";
import batchesbycouresIdReducer from "../Redux/features/TestSeries/betchbyCourseIdSlice";
import FavReducer from "../Redux/Fav/FavSlice";
import ScopeReducer from "../Redux/Scope/ScopeSlice";
import sessionReducer from "../Redux/Sessions/sessionSlice";

// Browser user info
import  setUserBrowserInfo  from "../Redux/UserBrowserEtcInfo/UserBrowserEtcInfo";

export default configureStore({
  reducer: {
    landing: landingReducer,
    createRole: createRoleReducer,
    religion: religionReducer,
    gender: genderReducer,
    bloodgroup: bloodgroupReducer,
    department: departmentReducer,
    grade: gradeReducer,
    salutations: salutationReducer,
    categories: categoryReducer,
    subcategoies: subcategoryReducer,
    course: courseReducer,
    coaching: coachingReducer,
    schoolname: schoolNameReducer,
    classname: classReducer,
    medium: mediumReducer,
    board: boearReducer,
    domstate: stateReducer,
    classType: classTypeReducer,
    batchename: batchReducer,
    testname: testNameReducer,
    testSeries: testSeriesReducer,
    batchNameByCourseId: batchesbycouresIdReducer,
    fav: FavReducer,
    scopes: ScopeReducer,
    UserBrowserInfo : setUserBrowserInfo,
    sessions: sessionReducer,
  },
});
